import React from "react";

export default props => <h2 className="block--title">{props.blockTitle}</h2>